// removed by extract-text-webpack-plugin
module.exports = {"sponsors":"_3Dvmnqxr6eUGlUjdRtfBW_","flexContainer":"_3cCLjIFV529x1JcQ5pdrsv","coOrganizorLabel":"e_Xgw3xC6Z0UQcAw8rew7","sponsorLabel":"_2MPDPXKBJ3740gGJ6O9zR4","sponsorContainer":"_3c4NMnvdD2VkvoMYoMGEU_","sponsorLabel2":"_2Xap3gTbXJy9R6zrTFNLDe","sponsorContainer2":"_2Frrg_VS1RBV9GtigrqBlA","sponsorList":"_2LjqRrBBlebB-8NQn6SCer","sponsorTitle":"_2QUZLHHBJGF6R8usJzA9yS","sponsorItem":"_3ht4hKofR1L-xkoliEUKs3","sponsorItemSony":"_3U744LkFI-ESmoRFAyxRWJ","sponsorItemSony2":"VrbsO9crhK5NKsVSe0q-6","center":"_2Gm5-rfOQQRh4rkydII9Z5","halfImage":"_3StoFnleBYHRFktHSET0L","section":"_1e1LpOCPLHy5cpKXXEdJg_"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Sponsors/Sponsors.css
// module id = 190
// module chunks = 0